
























































































































import { MessageDialog } from '../../utils/MessageDialog';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { dayjs, D_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { Session } from '../../utils/Session';
import { getBuildingName } from '../../../src_server/entity/master/buildingData';
import { ReportDTO } from '../../../src_server/entity/dto/ReportDTO';
import { DaDailyReportService } from '../../biz/remote/DaDailyReportService';
import { basicStrengthTitle, getBasicStrengthLevelTitle } from '../../../src_server/entity/master/basicStrengthData';

@Component({
  components: {},
  filters: {
    formatDt: (dt: Date) => {
      return dayjs(dt).format(D_FORMAT_JA);
    },
  },
})
export default class ReportPrintPage extends Vue {
  private dto: ReportDTO[] = [];

  get buildingName() {
    return getBuildingName(Session.getSessionBuildingId());
  }

  crtfToBR(str: string) {
    return str.replaceAll('\n', '<BR>');
  }

  getItem(itemName: string) {
    return basicStrengthTitle[itemName];
  }
  getBasicStrengthLevelTitle(item: string, level: number) {
    return getBasicStrengthLevelTitle(item, level);
  }

  async created() {
    const class_id_param = this.$route.query.class_id as string;
    if (!class_id_param) {
      await MessageDialog.systemError('レッスンID', '日報印刷ページ表示時', class_id_param);
      return;
    }

    const class_id_list = class_id_param.split(',');
    if (class_id_list.length === 0) {
      await MessageDialog.alert(`該当する日報がありませんでした。`);
      this.close();
      return;
    }

    // 日報データを取得
    const biz = new DaDailyReportService();
    const resonse = await biz.getReportsForPrint(class_id_list);
    if (resonse.hasError) {
      await MessageDialog.systemError('日報', '日報印刷ページ表示時', resonse.data);
      return;
    }
    this.dto = resonse.data;
  }

  async print() {
    window.print();
  }
  async close() {
    window.close();
  }
}
